import React, { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/Production/Form/WeeklyTimeSheet/index'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import {
    v2_builders,
    v2_projects,
    v2_ships,
} from '../../../actions/v2/projectAndVessel';
import {
    v3_fetchWeeklyTimeSheetFields,
    v3_submitWeeklyTimeSheet,

} from '../../../actions/v3/productionForm';
import Swal from 'sweetalert2';
import { v2_ship_owners } from '../../../actions/v2/masterData';
import { getSessionStorage, getStorage } from '../../../utils';

const NewBuildingWeeklyTimeSheet = (props) => {

    const [ud, set_ud] = useState(JSON.parse(atob(getSessionStorage(constant.keys.userDetails))));
    console.log(ud)
    const location = useLocation();
    const { data } = location.state || {};

    const defaultRow = {
        hull: { name: 'hull', value: '', error: '', isRequired: true },
        activity_description: { name: 'activity_description', value: '', error: '', isRequired: true },
        extra_details: { name: 'extra_details', value: '', error: '', isRequired: false },
        day1: { name: 'day1', value: '', error: '', isRequired: false },
        day2: { name: 'day2', value: '', error: '', isRequired: false },
        day3: { name: 'day3', value: '', error: '', isRequired: false },
        day4: { name: 'day4', value: '', error: '', isRequired: false },
        day5: { name: 'day5', value: '', error: '', isRequired: false },
        day6: { name: 'day6', value: '', error: '', isRequired: false },
        day7: { name: 'day7', value: '', error: '', isRequired: false },
        totalHullHours: { name: 'totalHullHours', value: '', error: '', isRequired: false },
    };
    const [state, setState] = useState([defaultRow]);

    const [summary, setSummary] = useState({
        totalHourWorkedinDay1: { name: 'totalHourWorkedinDay1', value: '', error: '', isRequired: false },
        totalHourWorkedinDay2: { name: 'totalHourWorkedinDay2', value: '', error: '', isRequired: false },
        totalHourWorkedinDay3: { name: 'totalHourWorkedinDay3', value: '', error: '', isRequired: false },
        totalHourWorkedinDay4: { name: 'totalHourWorkedinDay4', value: '', error: '', isRequired: false },
        totalHourWorkedinDay5: { name: 'totalHourWorkedinDay5', value: '', error: '', isRequired: false },
        totalHourWorkedinDay6: { name: 'totalHourWorkedinDay6', value: '', error: '', isRequired: false },
        totalHourWorkedinDay7: { name: 'totalHourWorkedinDay7', value: '', error: '', isRequired: false },

        annualLeaveInDay1: { name: 'annualLeaveInDay1', value: '', error: '', isRequired: false },
        annualLeaveInDay2: { name: 'annualLeaveInDay2', value: '', error: '', isRequired: false },
        annualLeaveInDay3: { name: 'annualLeaveInDay3', value: '', error: '', isRequired: false },
        annualLeaveInDay4: { name: 'annualLeaveInDay4', value: '', error: '', isRequired: false },
        annualLeaveInDay5: { name: 'annualLeaveInDay5', value: '', error: '', isRequired: false },
        annualLeaveInDay6: { name: 'annualLeaveInDay6', value: '', error: '', isRequired: false },
        annualLeaveInDay7: { name: 'annualLeaveInDay7', value: '', error: '', isRequired: false },

        holidayInDay1: { name: 'holidayInDay1', value: '', error: '', isRequired: false },
        holidayInDay2: { name: 'holidayInDay2', value: '', error: '', isRequired: false },
        holidayInDay3: { name: 'holidayInDay3', value: '', error: '', isRequired: false },
        holidayInDay4: { name: 'holidayInDay4', value: '', error: '', isRequired: false },
        holidayInDay5: { name: 'holidayInDay5', value: '', error: '', isRequired: false },
        holidayInDay6: { name: 'holidayInDay6', value: '', error: '', isRequired: false },
        holidayInDay7: { name: 'holidayInDay7', value: '', error: '', isRequired: false },

        sickLeaveInDay1: { name: 'sickLeaveInDay1', value: '', error: '', isRequired: false },
        sickLeaveInDay2: { name: 'sickLeaveInDay2', value: '', error: '', isRequired: false },
        sickLeaveInDay3: { name: 'sickLeaveInDay3', value: '', error: '', isRequired: false },
        sickLeaveInDay4: { name: 'sickLeaveInDay4', value: '', error: '', isRequired: false },
        sickLeaveInDay5: { name: 'sickLeaveInDay5', value: '', error: '', isRequired: false },
        sickLeaveInDay6: { name: 'sickLeaveInDay6', value: '', error: '', isRequired: false },
        sickLeaveInDay7: { name: 'sickLeaveInDay7', value: '', error: '', isRequired: false },


        authorisedUnpaidLeaveInDay1: { name: 'authorisedUnpaidLeaveInDay1', value: '', error: '', isRequired: false },
        authorisedUnpaidLeaveInDay2: { name: 'authorisedUnpaidLeaveInDay2', value: '', error: '', isRequired: false },
        authorisedUnpaidLeaveInDay3: { name: 'authorisedUnpaidLeaveInDay3', value: '', error: '', isRequired: false },
        authorisedUnpaidLeaveInDay4: { name: 'authorisedUnpaidLeaveInDay4', value: '', error: '', isRequired: false },
        authorisedUnpaidLeaveInDay5: { name: 'authorisedUnpaidLeaveInDay5', value: '', error: '', isRequired: false },
        authorisedUnpaidLeaveInDay6: { name: 'authorisedUnpaidLeaveInDay6', value: '', error: '', isRequired: false },
        authorisedUnpaidLeaveInDay7: { name: 'authorisedUnpaidLeaveInDay7', value: '', error: '', isRequired: false },


        grandTotalWorkingHour: { name: 'grandTotalWorkingHour', value: '', error: '', isRequired: false },
        grandTotalAnnualLeave: { name: 'grandTotalAnnualLeave', value: '', error: '', isRequired: false },
        grandTotalHoliday: { name: 'grandTotalHoliday', value: '', error: '', isRequired: false },
        grandTotalSickLeave: { name: 'grandTotalSickLeave', value: '', error: '', isRequired: false },

        grandTotalAuthorisedUnpaidLeave: { name: 'grandTotalAuthorisedUnpaidLeave', value: '', error: '', isRequired: false },

    });
    const [commonDetails, setCommonDetails] = useState({
        project: { value: '', options: [], error: '' },
        builder: { value: '', options: [], error: '' },
        weekEndingSunday: { value: '', error: '' },
        jobTitle: { value: '' },
        name: { value: '' },
        owner: { value: '', options: [] },
        finalSubmit: { value: '' },
    });
    const handleSummaryChange = (e) => {
        const { name, value } = e.target;
        setSummary(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value,
                error: '', // Optionally clear the error on change
            }
        }));
    };

    const [hullOptions, setHullOptions] = useState([]);




    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        v2_builders().then((res) => {
            if (res.status) {
                setCommonDetails((prev) => ({
                    ...prev,
                    builder: { ...prev.builder, options: res.result },
                }));
            }
        });


    }, []);

    useEffect(() => {
        if (commonDetails.project.value) {
            v2_ships(null, commonDetails.project.value).then((res) => {
                if (res.status) {
                    setHullOptions(res.result);
                }
            });
        } else {
            setHullOptions([]);
        }
    }, [commonDetails.project.value]);

    useEffect(() => {
        v2_ship_owners().then((res) => {
            if (res.status) {
                setCommonDetails(prev => ({
                    ...prev,
                    owner: {
                        ...prev.owner,
                        options: res.result || [],
                    }
                }));
            }
        });

        v2_projects().then((res) => {
            if (res.status) {
                setCommonDetails(prev => ({
                    ...prev,
                    project: {
                        ...prev.project,
                        options: res.result || [],
                    }
                }));
            }
        })
    }, []);

    const addRow = () => {
        setState(prev => [...prev, JSON.parse(JSON.stringify(defaultRow))]);
    };



    const handleChange = (field, value, index = 0) => {
        setState((prevState) => {
            const updatedState = [...prevState];

            // Update the changed field
            updatedState[index][field] = {
                ...updatedState[index][field],
                value,
                error: '',
            };

            // Recalculate row-wise totalHullHours for the modified row
            const updatedRow = updatedState[index];
            const rowTotal = ['day1', 'day2', 'day3', 'day4', 'day5', 'day6', 'day7'].reduce((sum, dayKey) => {
                const val = parseFloat(updatedRow[dayKey]?.value);
                return sum + (isNaN(val) ? 0 : val);
            }, 0);

            updatedState[index].totalHullHours = {
                ...updatedRow.totalHullHours,
                value: rowTotal,
            };

            // Recalculate column-wise totals and grand total
            const newSummary = { ...summary };
            let grandTotalWorking = 0;

            for (let day = 1; day <= 7; day++) {
                const dayKey = `day${day}`;
                const summaryKey = `totalHourWorkedinDay${day}`;

                const dayTotal = updatedState.reduce((sum, row) => {
                    const val = parseFloat(row[dayKey]?.value);
                    return sum + (isNaN(val) ? 0 : val);
                }, 0);

                newSummary[summaryKey] = {
                    ...newSummary[summaryKey],
                    value: dayTotal,
                };

                grandTotalWorking += dayTotal;
            }

            newSummary.grandTotalWorkingHour = {
                ...newSummary.grandTotalWorkingHour,
                value: grandTotalWorking,
            };

            // Apply state updates
            setSummary(newSummary);
            return updatedState;
        });
    };



    const onSubmit = async () => {
        const errors = [];

        // Validate common project selection
        if (!commonDetails.project.value) {
            errors.push('Please select a project.');
        }

        if (!commonDetails.jobTitle.value) {
            errors.push('Please enter a job title.');
        }

        if (!commonDetails.builder.value) {
            errors.push('Please select a builder.');
        }

        if (!commonDetails.weekEndingSunday.value) {
            errors.push('Please provide the week ending Sunday date.');
        }

        if (!commonDetails.owner.value) {
            errors.push('Please select an owner.');
        }

        if (commonDetails.finalSubmit.value) {
            // Validate each row in the state
            state.forEach((row, index) => {
                Object.entries(row).forEach(([key, field]) => {
                    if (key === 'entryId') return; // Skip entryId
                    const isRequired = field.isRequired;
                    if (isRequired && !field.value) {
                        const fieldName = key.replace(/_/g, ' ');
                        errors.push(`Row ${index + 1}: ${fieldName} is required.`);
                    }
                });
            });

            // Optional: Validate summary fields if needed
            Object.entries(summary).forEach(([key, field]) => {
                if (field.isRequired && !field.value) {
                    const fieldName = key.replace(/([A-Z])/g, ' $1'); // Add space before capital letters
                    errors.push(`Summary: ${fieldName.trim()} is required.`);
                }
            });
        }

        if (errors.length > 0) {
            toast.error(
                <div>
                    {errors.map((err, i) => (
                        <div key={i}>• {err}</div>
                    ))}
                </div>
            );
            return;
        }


        // Confirm final submission
        if (commonDetails.finalSubmit.value) {
            const confirmResult = await Swal.fire({
                title: 'Are you sure?',
                text: 'Do you want to submit the reports for Office Review?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it',
                cancelButtonText: 'Cancel',
            });

            if (!confirmResult.isConfirmed) return;
        }

        // Format checklist items
        const checklistItems = state.map((row) => {
            const formattedRow = {};
            Object.keys(row).forEach((key) => {
                if (key === 'entryId') {
                    formattedRow['ID'] = row[key];
                } else {
                    formattedRow[key] = row[key]?.value || '';
                }
            });
            return formattedRow;
        });

        // Format summary
        const formattedSummary = {};
        Object.entries(summary).forEach(([key, field]) => {
            formattedSummary[key] = field.value || '';
        });

        // Construct payload
        const payload = {
            commonDetails: {
                project: commonDetails.project.value,
                weekEndingSunday: commonDetails.weekEndingSunday.value,
                owner: commonDetails.owner.value,
                builder: commonDetails.builder.value,
                jobTitle: commonDetails.jobTitle.value,
                name: commonDetails.name.value,
                finalSubmit: commonDetails.finalSubmit.value,
            },
            checklistItems,
            summary: formattedSummary
        };

        // Submit
        v3_submitWeeklyTimeSheet(payload).then((res) => {
            if (res.status) {
                toast.success(res.result.message);
                props.history.push(constant.Authedcomponent.production.url);
            }
        });
    };

    useEffect(() => {
        const params = data ? JSON.parse(atob(data)) : null;
        if (params) {
            setShowLoader(true);

            v3_fetchWeeklyTimeSheetFields(
                params.PROJECT_ID,
                params.FORM_ID
            )
                .then((res) => {
                    if (res.status) {

                        // set common details if editing
                        if (params.PROJECT_ID) {
                            setCommonDetails((prev) => ({
                                ...prev,
                                project: { ...prev.project, value: res.result.commonDetails?.PROJECT_ID || '' },
                                owner: { ...prev.owner, value: res.result.commonDetails?.OWNER_ID || '' },
                                finalSubmit: { ...prev.finalSubmit, value: Boolean(res.result.commonDetails?.FINAL_SUBMITTED) },
                                weekEndingSunday: { ...prev.weekEndingSunday, value: res.result.commonDetails?.WEEK_ENDING_SUNDAY || '' },
                                builder: { ...prev.builder, value: res.result.commonDetails?.BUILDER_ID || '' },
                                jobTitle: { ...prev.jobTitle, value: res.result.commonDetails?.JOB_TITLE || '' },
                                name: { ...prev.name, value: res.result.commonDetails?.USER_NAME || '' },
                            }));
                        }

                        // convert flat records to form model
                        const mappedItems = res.result.records.map((item) => {
                            return {
                                entryId: item.ID,
                                hull: {
                                    ...defaultRow.hull,
                                    value: item.SHIP_ID || '',
                                },
                                activity_description: {
                                    ...defaultRow.activity_description,
                                    value: item.ACTIVITY_DESCRIPTION || '',
                                },
                                extra_details: {
                                    ...defaultRow.extra_details,
                                    value: item.OTHER_DETAILS || '',
                                },
                                day1: {
                                    ...defaultRow.day1,
                                    value: item.DAY_1 || '',
                                },
                                day2: {
                                    ...defaultRow.day2,
                                    value: item.DAY_2 || '',
                                },
                                day3: {
                                    ...defaultRow.day3,
                                    value: item.DAY_3 || '',
                                },
                                day4: {
                                    ...defaultRow.day4,
                                    value: item.DAY_4 || '',
                                },
                                day5: {
                                    ...defaultRow.day5,
                                    value: item.DAY_5 || '',
                                },
                                day6: {
                                    ...defaultRow.day6,
                                    value: item.DAY_6 || '',
                                },

                                day7: {
                                    ...defaultRow.day7,
                                    value: item.DAY_7 || '',
                                },
                                totalHullHours: {
                                    ...defaultRow.totalHullHours,
                                    value: item.TOTAL_HOURS || '',
                                },
                            };
                        });
                        setState(mappedItems);


                        setSummary((prev) => ({
                            ...prev,

                            // Working hours
                            totalHourWorkedinDay1: { ...prev.totalHourWorkedinDay1, value: res.result.commonDetails?.GRAND_TOTAL_WORKING_HOUR_DAY_1 || '' },
                            totalHourWorkedinDay2: { ...prev.totalHourWorkedinDay2, value: res.result.commonDetails?.GRAND_TOTAL_WORKING_HOUR_DAY_2 || '' },
                            totalHourWorkedinDay3: { ...prev.totalHourWorkedinDay3, value: res.result.commonDetails?.GRAND_TOTAL_WORKING_HOUR_DAY_3 || '' },
                            totalHourWorkedinDay4: { ...prev.totalHourWorkedinDay4, value: res.result.commonDetails?.GRAND_TOTAL_WORKING_HOUR_DAY_4 || '' },
                            totalHourWorkedinDay5: { ...prev.totalHourWorkedinDay3, value: res.result.commonDetails?.GRAND_TOTAL_WORKING_HOUR_DAY_5 || '' },
                            totalHourWorkedinDay6: { ...prev.totalHourWorkedinDay6, value: res.result.commonDetails?.GRAND_TOTAL_WORKING_HOUR_DAY_6 || '' },
                            totalHourWorkedinDay7: { ...prev.totalHourWorkedinDay7, value: res.result.commonDetails?.GRAND_TOTAL_WORKING_HOUR_DAY_7 || '' },

                            // Annual leave
                            annualLeaveInDay1: { ...prev.annualLeaveInDay1, value: res.result.commonDetails?.ANNUAL_LEAVE_DAY_1 || '' },
                            annualLeaveInDay2: { ...prev.annualLeaveInDay2, value: res.result.commonDetails?.ANNUAL_LEAVE_DAY_2 || '' },
                            annualLeaveInDay3: { ...prev.annualLeaveInDay3, value: res.result.commonDetails?.ANNUAL_LEAVE_DAY_3 || '' },
                            annualLeaveInDay4: { ...prev.annualLeaveInDay4, value: res.result.commonDetails?.ANNUAL_LEAVE_DAY_4 || '' },
                            annualLeaveInDay5: { ...prev.annualLeaveInDay5, value: res.result.commonDetails?.ANNUAL_LEAVE_DAY_5 || '' },
                            annualLeaveInDay6: { ...prev.annualLeaveInDay6, value: res.result.commonDetails?.ANNUAL_LEAVE_DAY_6 || '' },
                            annualLeaveInDay7: { ...prev.annualLeaveInDay7, value: res.result.commonDetails?.ANNUAL_LEAVE_DAY_7 || '' },

                            // Holidays
                            holidayInDay1: { ...prev.holidayInDay1, value: res.result.commonDetails?.HOLIDAY_DAY_1 || '' },
                            holidayInDay2: { ...prev.holidayInDay2, value: res.result.commonDetails?.HOLIDAY_DAY_2 || '' },
                            holidayInDay3: { ...prev.holidayInDay3, value: res.result.commonDetails?.HOLIDAY_DAY_3 || '' },
                            holidayInDay4: { ...prev.holidayInDay4, value: res.result.commonDetails?.HOLIDAY_DAY_4 || '' },
                            holidayInDay5: { ...prev.holidayInDay5, value: res.result.commonDetails?.HOLIDAY_DAY_5 || '' },
                            holidayInDay6: { ...prev.holidayInDay6, value: res.result.commonDetails?.HOLIDAY_DAY_6 || '' },
                            holidayInDay7: { ...prev.holidayInDay7, value: res.result.commonDetails?.HOLIDAY_DAY_7 || '' },

                            // Sick leaves
                            sickLeaveInDay1: { ...prev.sickLeaveInDay1, value: res.result.commonDetails?.SICK_LEAVE_DAY_1 || '' },
                            sickLeaveInDay2: { ...prev.sickLeaveInDay2, value: res.result.commonDetails?.SICK_LEAVE_DAY_2 || '' },
                            sickLeaveInDay3: { ...prev.sickLeaveInDay3, value: res.result.commonDetails?.SICK_LEAVE_DAY_3 || '' },
                            sickLeaveInDay4: { ...prev.sickLeaveInDay4, value: res.result.commonDetails?.SICK_LEAVE_DAY_4 || '' },
                            sickLeaveInDay5: { ...prev.sickLeaveInDay5, value: res.result.commonDetails?.SICK_LEAVE_DAY_5 || '' },
                            sickLeaveInDay6: { ...prev.sickLeaveInDay6, value: res.result.commonDetails?.SICK_LEAVE_DAY_6 || '' },
                            sickLeaveInDay7: { ...prev.sickLeaveInDay7, value: res.result.commonDetails?.SICK_LEAVE_DAY_7 || '' },

                            // Authorised unpaid leaves
                            authorisedUnpaidLeaveInDay1: { ...prev.authorisedUnpaidLeaveInDay1, value: res.result.commonDetails?.AUTHORISED_UNPAID_LEAVE_DAY_1 || '' },
                            authorisedUnpaidLeaveInDay2: { ...prev.authorisedUnpaidLeaveInDay2, value: res.result.commonDetails?.AUTHORISED_UNPAID_LEAVE_DAY_2 || '' },
                            authorisedUnpaidLeaveInDay3: { ...prev.authorisedUnpaidLeaveInDay3, value: res.result.commonDetails?.AUTHORISED_UNPAID_LEAVE_DAY_3 || '' },
                            authorisedUnpaidLeaveInDay4: { ...prev.authorisedUnpaidLeaveInDay4, value: res.result.commonDetails?.AUTHORISED_UNPAID_LEAVE_DAY_4 || '' },
                            authorisedUnpaidLeaveInDay5: { ...prev.authorisedUnpaidLeaveInDay5, value: res.result.commonDetails?.AUTHORISED_UNPAID_LEAVE_DAY_5 || '' },
                            authorisedUnpaidLeaveInDay6: { ...prev.authorisedUnpaidLeaveInDay6, value: res.result.commonDetails?.AUTHORISED_UNPAID_LEAVE_DAY_6 || '' },
                            authorisedUnpaidLeaveInDay7: { ...prev.authorisedUnpaidLeaveInDay7, value: res.result.commonDetails?.AUTHORISED_UNPAID_LEAVE_DAY_7 || '' },
                        }));

                        // set state (renamed from state to items if needed)
                    } else {
                        toast.error(res.error);
                    }
                })
                .catch(() => toast.error('Something went wrong while fetching.'))
                .finally(() => setShowLoader(false));
        }

    }, []);

    // console.log(state)
    return (
        <Layout title="Weekly Time Sheet">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body">
                            <div className="checklist-title-bx">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="text-center">
                                            <h4>Weekly Time Sheet</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 ">
                                    <div className="report-index-top weekly-index-top">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="hd-s2 pl10">
                                                        <p>Builder</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <select
                                                            className="form-select"
                                                            value={commonDetails.builder.value}
                                                            disabled={data ? true : false}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    builder: { ...prev.builder, value: e.target.value },
                                                                }))
                                                            }
                                                        >

                                                            <option value={''}>Select Builder</option>
                                                            {commonDetails.builder.options.map((item) => {
                                                                return (<option value={item.ID}>{item.BUILDER_NAME}</option>)
                                                            })}
                                                        </select>
                                                    </td>
                                                    <td className="hd-s2 pl10">
                                                        <p>Week Ending Sunday</p>
                                                    </td>
                                                    <td className="td-input-bx">


                                                        <DatePicker
                                                            selected={
                                                                commonDetails.weekEndingSunday.value
                                                                    ? new Date(commonDetails.weekEndingSunday.value)
                                                                    : null
                                                            }
                                                            onChange={(date) => {
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    weekEndingSunday: {
                                                                        ...prev.weekEndingSunday,
                                                                        value: date.toISOString().split('T')[0],
                                                                    },
                                                                }));
                                                            }}
                                                            disabled={!!data}
                                                            filterDate={(date) => date.getDay() === 0} // Only allow Sundays
                                                            placeholderText="Select a Sunday"
                                                            className="form-control"
                                                            dateFormat="yyyy-MM-dd"
                                                        />

                                                    </td>
                                                    <td className="hd-s2 pl10">
                                                        <p>Owner</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <select className={"form-select"}
                                                            disabled={data ? true : false}
                                                            value={commonDetails.owner.value}
                                                            onChange={(e) => setCommonDetails((prev) => ({
                                                                ...prev,
                                                                owner: { ...prev.owner, value: e.target.value },
                                                            }))}

                                                        >
                                                            <option value={''}>Select Owner</option>
                                                            {commonDetails.owner.options?.map((item) => {
                                                                return (<option value={item.ID}>{item.OWNER_NAME}</option>)
                                                            })}
                                                        </select>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="hd-s2 pl10">
                                                        <p>Name</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder=""
                                                            value={commonDetails.name.value || ud.fullName}
                                                        />
                                                    </td>
                                                    <td className="hd-s2 pl10">
                                                        <p>Project</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <select
                                                            className="form-select"
                                                            value={commonDetails.project.value}
                                                            disabled={data ? true : false}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    project: { ...prev.project, value: e.target.value },
                                                                }))
                                                            }
                                                        >

                                                            <option value={''}>Select Project</option>
                                                            {commonDetails.project.options.map((item) => {
                                                                return (<option value={item.ID}>{item.PROJECT_CODE} - {item.PROJECT_NAME}</option>)
                                                            })}
                                                        </select>
                                                    </td>
                                                    <td className="hd-s2 pl10">
                                                        <p>Job Title</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <input
                                                            type='text'
                                                            className="form-control"
                                                            value={commonDetails.jobTitle.value}
                                                            disabled={data ? true : false}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    jobTitle: { ...prev.jobTitle, value: e.target.value },
                                                                }))
                                                            }
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <Form
                                onChange={handleChange}
                                weekEndingSunday={commonDetails.weekEndingSunday.value}
                                state={state}
                                onSubmit={onSubmit}
                                addRow={addRow}
                                isFinalSubmitting={commonDetails.finalSubmit.value}
                                setIsFinalSubmitting={() => setCommonDetails((prev) => ({
                                    ...prev,
                                    finalSubmit: { ...prev.finalSubmit, value: !commonDetails.finalSubmit.value },
                                }))}
                                hullOptions={hullOptions}
                                handleSummaryChange={handleSummaryChange}
                                summary={summary}
                            />


                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default NewBuildingWeeklyTimeSheet